if (!customElements.get('accordion-item')) {
  class AccordionItem extends customElements.get(
    'dropdown-disclosure'
  ) {
    constructor() {
      super();
      this.accordionHeight = 0;
    }

    connectedCallback() {
      this.updateAccordionHeight();
      this.querySelector('details').open = false;
    }

    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');

        const accordionContentHeight =
          this.querySelector('summary').nextElementSibling
            .scrollHeight;
        if (parseInt(this.accordionHeight) < accordionContentHeight) {
          this.updateAccordionHeight();
        }
      }, 200);

      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(detailsElement, summaryElement);
    }

    updateAccordionHeight() {
      this.accordionHeight =
        this.querySelector('summary').nextElementSibling
          .scrollHeight + 'px';
      this.style.setProperty('--max-height', this.accordionHeight);
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
